import React from "react"

interface Props {
  children: React.ReactNode
}

export const EmptyState = ({ children }: Props) => (
  <div className="empty-state">{children}</div>
)
